module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/1.28bf4378.png";